import React from 'react';
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import {User} from "fearless-common";
import Loading from "../Loading";
import useGet from "../hooks/useGet";
import {backendEndpoints} from "../../libs/backendEndpoints";
import SubscriptionInvoicesModal from './SubscriptionInvoicesModal';


export default function BillingDashboardButton({ user, groupId, subscriptionId }: { user?: User; groupId?: number | null; subscriptionId: number }) {
    let endpoint = '';
    if (user?.is_subscribed) {
        endpoint = backendEndpoints.billingPortal
    } else if (groupId) {
        endpoint = backendEndpoints.groupBillingPortal(groupId)
    }
    const { data: url, isLoading, error } = useGet<string>({ endpoint })


    return (
        <>
            {typeof url === 'string' && url.indexOf('https://billing.stripe.com') === 0 ? (
                <a href={url} target="_blank" rel="noreferrer">
                    <Button variant="outline-secondary mb-2" disabled={isLoading}>
                        Manage payment &rarr;
                    </Button>
                    <br />
                </a>
            ) : (
              <>
                  <Button variant="outline-secondary mb-2" disabled={isLoading}>
                      Manage payment {isLoading && <Loading size="sm" />}
                  </Button>
              </>
            )}
            <SubscriptionInvoicesModal subscriptionId={subscriptionId} />

            {error && <Alert>{error}</Alert>}
        </>
    );
}
